/**
 * DropIndicator — blue rule showing where a dragged block will land.
 * Absolute-positioned by the parent (which must be `position: relative`).
 */
export function DropIndicator() {
  return (
    <div
      className="absolute left-0 right-0"
      style={{
        top: -2, height: 2, borderRadius: 2,
        background: 'var(--color-business)',
        boxShadow: '0 0 0 1px color-mix(in srgb, var(--color-business) 40%, transparent)',
      }}
    />
  )
}
